import React, { useEffect, useRef, useState } from 'react';
import {getType,getOperationView, getProducer, textTypes} from '../../helpers/helper.filters'
import Breadcrumbs from "../breadcrumbs";
import { graphql, useStaticQuery } from 'gatsby';
import { connect } from 'react-redux'
import { redux_updateOrders } from '../../redux/propertiesDucks';
    

const HeaderResults = ({filters,totalCount,loading,menu,viewId,setMenu,dispatch}) => {

    const [orders,setOrders] = useState({order:'desc',order_by:'id'})

    const { realEstate } = useStaticQuery(graphql`
    query {
        realEstate {
            name
            template_version
        }
    }`)
    const {template_version} = realEstate
    const MediaPro = template_version === 'PRO' ? true : false;
    const selectorOrder = useRef()

    function traductorSelect(){
        switch(selectorOrder.current.value){
          case '0': setOrders({order:'desc',order_by:'price'}); break;
          case '1': setOrders({order:'asc',order_by:'price'}); break;
          case '2': setOrders({order:'desc',order_by:'id'}); break;
          case '3': setOrders({order:'asc',order_by:'id'}); break;
          case '4': setOrders({order:'desc',order_by:'total_surface'}); break;
          case '5': setOrders({order:'asc',order_by:'total_surface'}); break;
        }
    }

    useEffect(() => {
        dispatch(redux_updateOrders(orders))
    },[orders])

    return viewId === 2 && (
        <div className="py-lg-3 pb-lg-4 pb-2 col-12 container-fluid px-lg-4">
            <div className="row">
                <div className="col-12 mt-lg-3">
                    <Breadcrumbs
                            props={[
                            { name: realEstate.name, route: "/", location: "" },
                            { name: getOperationView(filters), route:   "", location: ""},
                            ]}
                            skeleton={getOperationView(filters) ? false : true}
                        />
                </div>
                <div class="col-lg-6 mt-0 mt-lg-0">
                    <div class="section-title pt-0 pt-lg-0 pb-lg-0">
                        <h1 className={!getOperationView(filters) && "mt-lg-3 skeleton"}>{getType(filters)?.length > 0 ? textTypes(getType(filters)) : 'Propiedades'} en {getOperationView(filters)} <div className="d-inline-block text-capitalize">{ getProducer(filters)}</div></h1>
                        <br className="d-lg-none" />
                        <h5 className={(loading && "skeleton my-2") + ' d-lg-none'}>{loading ? 'Cargando' : totalCount} resultados totales de búsqueda. </h5>
                    </div>
                    
                </div>
                {!MediaPro && <div class="col-6 d-none d-lg-flex align-items-center justify-content-end">
                    <p onClick={() => document.body.classList.toggle("overflow-hidden") + setMenu(!menu)} id="openFilter" class="d-lg-flex d-none align-items-center justify-content-end"><i class="icon-filters me-4"></i><h4 className="mb-0">FILTROS DE BÚSQUEDA</h4></p>
                </div>}
                <div class="col-12 justify-content-end d-flex align-items-center mt-lg-2 mb-lg-2" id="orderBy">
                    <h5 className={(loading && "skeleton") + ' d-none d-lg-block col-6 mb-lg-0'}>{loading ? 'Cargando' : totalCount} resultados totales de búsqueda. </h5>

                    <div class="content-select col-lg-6 text-end me-0">
                    <select ref={selectorOrder} onChange={() => traductorSelect()} className="text-end me-lg-0" name="orderby" id="sort">
                        <option value="2">Publicaciones más recientes</option>
                        <option value="3">Publicaciones más antiguas</option>
                        <option value="0">Mayor precio</option>
                        <option value="1">Menor precio</option>
                        <option value="4">Mayor superficie</option>
                        <option value="5">Menor superficie</option>
                    </select>
                    <i></i>
                    </div>
                </div>
            </div>
        </div>
           
    )
}

export default connect(state => ({
    filters: state.properties.filters,
    totalCount: state.properties.totalCount,
    loading: state.properties.loading
}),null)(HeaderResults);